package kz.dentalcrm.app.di

import kz.dentalcrm.app.screens.login.LoginViewModel
import kz.dentalcrm.app.screens.main.MainViewModel
import kz.dentalcrm.app.screens.appointments.AppointmentsViewModel
import kz.dentalcrm.app.screens.appointments.add.AddAppointmentViewModel
import kz.dentalcrm.app.screens.diagnosis.add.AddDiagnosisViewModel
import kz.dentalcrm.app.screens.diagnosis.edit.EditDiagnosisViewModel
import kz.dentalcrm.app.screens.diagnosis.list.DiagnosisViewModel
import kz.dentalcrm.app.screens.employees.EmployeesViewModel
import kz.dentalcrm.app.screens.employees.add.AddEmployeeViewModel
import kz.dentalcrm.app.screens.menu.MenuViewModel
import kz.dentalcrm.app.screens.patients.PatientViewModel
import kz.dentalcrm.app.screens.patients.add.AddPatientModel
import kz.dentalcrm.app.screens.patients.detail.PatientDetailViewModel
import kz.dentalcrm.app.screens.protocols.add.AddProtocolViewModel
import kz.dentalcrm.app.screens.protocols.edit.EditProtocolViewModel
import kz.dentalcrm.app.screens.protocols.list.ProtocolsViewModel
import kz.dentalcrm.app.screens.services.add.AddServiceViewModel
import kz.dentalcrm.app.screens.services.detail.EditServiceViewModel
import kz.dentalcrm.app.screens.services.services.ServicesViewModel
import kz.dentalcrm.app.screens.splash.SplashViewModel
import kz.dentalcrm.app.screens.positions.list.PositionsViewModel
import kz.dentalcrm.app.screens.positions.add.AddPositionViewModel
import kz.dentalcrm.app.screens.positions.edit.EditPositionViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun viewModelModules() = module {
    viewModel { LoginViewModel() }
    viewModel { SplashViewModel() }
    viewModel { AppointmentsViewModel() }
    viewModel { AddPatientModel() }
    viewModel { PatientViewModel() }
    viewModel { EmployeesViewModel() }
    viewModel { AddEmployeeViewModel() }
    viewModel { AddServiceViewModel() }
    viewModel { EditServiceViewModel() }
    viewModel { AddDiagnosisViewModel() }
    viewModel { DiagnosisViewModel() }
    viewModel { EditDiagnosisViewModel() }
    viewModel { EditProtocolViewModel() }
    viewModel { AddProtocolViewModel() }
    viewModel { ProtocolsViewModel() }
    viewModel { MenuViewModel() }
    viewModel { MainViewModel() }
    viewModel { ServicesViewModel() }
    viewModel { PatientDetailViewModel() }
    viewModel { AddAppointmentViewModel() }
    viewModel { kz.dentalcrm.app.screens.employees.edit.EditEmployeeViewModel() }
    viewModel { PositionsViewModel() }
    viewModel { AddPositionViewModel() }
    viewModel { EditPositionViewModel() }
    viewModel { kz.dentalcrm.app.screens.service_categories.list.ServiceCategoriesViewModel() }
    viewModel { kz.dentalcrm.app.screens.service_categories.add.AddServiceCategoryViewModel() }
    viewModel { kz.dentalcrm.app.screens.service_categories.edit.EditServiceCategoryViewModel() }
    viewModel { kz.dentalcrm.app.screens.protocols.detail.DetailProtocolViewModel() }
    viewModel { kz.dentalcrm.app.screens.appointments.edit.EditAppointmentViewModel() }
    viewModel { kz.dentalcrm.app.screens.initial_inspection.InitialInspectionViewModel() }
    viewModel { kz.dentalcrm.app.screens.treatment.add.AddPatientTreatmentViewModel() }
    viewModel { kz.dentalcrm.app.screens.quick_replies.list.QuickRepliesViewModel() }
    viewModel { kz.dentalcrm.app.screens.quick_replies.add.AddQuickReplyViewModel() }
    viewModel { kz.dentalcrm.app.screens.quick_replies.edit.EditQuickReplyViewModel() }
    viewModel { kz.dentalcrm.app.screens.reply_by_template.ReplyByTemplateViewModel() }
}